import { HttpClient } from '@angular/common/http';
import { CacheService } from '../cache';
import { ResourceService } from './resource';
import { User, IUser } from '../../models/user';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TenantService extends ResourceService<User> {

  constructor(
    protected http: HttpClient,
    protected cache: CacheService
  ) {
    super(http, cache, 'tenants');
  }

}
